import MathTool from '../math/MathTool.js'
import GeomTool from '../geom/GeomTool.js'
import ColorTool from '../colors/ColorTool.js';

/**
 * Provides utility functions for drawing shapes and paths
 * @module DrawTool
 */
export default class DrawTool{

  // creates a linear gradient with random colors/alphas to emulate a deffective line stroke
  static getRandomLinearGradient( p0, p1, numSteps, colors, minAlpha, maxAlpha ){
    let ctx = window.p5App.drawingContext;
    let grd = ctx.createLinearGradient( p0.x, p0.y, p1.x, p1.y );
    //let lineLength = MathTool.distance( p0, p1 );
    let stepPositions = MathTool.getRandomValues( numSteps, 1, 0, "ASC"  );
    grd.addColorStop( 0, MathTool.randomElementFromArray( colors ) );
    for (let i = 0; i < numSteps; i++) {
      let color = MathTool.randomElementFromArray( colors );
      let alpha = MathTool.randomInRange( maxAlpha, minAlpha );
      color = ColorTool.addAlpha( color, alpha ); 
      grd.addColorStop(stepPositions[i], color );
    }
    grd.addColorStop( 1, MathTool.randomElementFromArray( colors ) );
    return grd;
  }

  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */  
  static setLinearGradient( p0, p1, colors ){
      let ctx = window.p5App.drawingContext;
      let grd = ctx.createLinearGradient( p0.x, p0.y, p1.x, p1.y );
      for (let i = 0; i < colors.length; i++) {
        const color = colors[i];
        grd.addColorStop(i/(colors.length-1), color);
      }   
      return grd;   
    }

    // function borrowed from: https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-using-html-canvas
    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static roundRect(ctx, x, y, width, height, radius, fill, stroke) {
        if (typeof stroke === 'undefined') {
          stroke = true;
        }
        if (typeof radius === 'undefined') {
          radius = 5;
        }
        if (typeof radius === 'number') {
          radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
          var defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
          for (var side in defaultRadius) {
            radius[side] = radius[side] || defaultRadius[side];
          }
        }
        ctx.beginPath();
        ctx.moveTo(x + radius.tl, y);
        ctx.lineTo(x + width - radius.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ctx.lineTo(x + width, y + height - radius.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ctx.lineTo(x + radius.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ctx.lineTo(x, y + radius.tl);
        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
        ctx.closePath();
        if (fill) {
          ctx.fill();
        }
        if (stroke) {
          ctx.stroke();
        }
      
      }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
      static drawLinesToPoints( point, points ){
        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            window.p5App.line( point.x, point.y, p.x, p.y );   
        }
    }
    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawPointArray( array ){
        for (let i = 0; i < array.length; i++) {
            const p = array[i];
            window.p5App.point( p.x, p.y );
        }
    }
    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawLinesArray( array ){
        for (let i = 0; i < array.length; i++) {
            const p0 = array[i].p0;
            const p1 = array[i].p1;
            window.p5App.line( p0.x, p0.y, p1.x, p1.y );
        }
    }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static dashedRectangle( x, y, width, height, numStrokes, slopeGlitch, borderGlitch ){
        for (let i = 0; i < numStrokes; i++) {

            let posX0 = x+MathTool.random()*borderGlitch+borderGlitch*0.5;
            let posX1 = x+width+MathTool.random()*borderGlitch+borderGlitch*0.5;
            let posY0 = MathTool.random()*height+y;
            let posY1 = posY0 + (MathTool.random()*slopeGlitch-slopeGlitch*0.5);
            window.p5App.line( posX0, posY0, posX1, posY1);            
        }
    }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static hairyCircle( x, y, radius, minHairLength, maxHairLength, numHairs ){
        for (let i = 0; i < numHairs; i++) {
            let length = minHairLength+Math.floor(MathTool.random()*(maxHairLength-minHairLength));
            window.p5App.stroke( 0,0,0,MathTool.random()*50);
            GeomTool.randomLineInCircle( radius, length, x, y );
          }
          for (let i = 0; i < numHairs; i++) {
            window.p5App.stroke( 0,0,0,MathTool.random()*50);
            let length = minHairLength+Math.floor(MathTool.random()*(maxHairLength-minHairLength));
            GeomTool.randomCurveInCircle( radius, length, x, y );
          }
    }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawPointsArrayAsDots( array, x, y ){
      DrawTool.drawPointsArrayAsCircles( array, x, y, 2 );
    }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static startDrawStyle(fillColor, strokeColor, strokeWeight){
      if( fillColor != null || strokeColor != null ) {
        p5App.push();
        if( fillColor != null ) 
          p5App.fill( fillColor );
        if( strokeColor != null ) {
          p5App.stroke( strokeColor );
          p5App.strokeWeight(strokeWeight)
        }
      }
    }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static endDrawStyle(fillColor, strokeColor){
      //if( fillColor != null || strokeColor != null ) {
        p5App.pop();
      //}
    }

    // Radius can be a number (all circles same radius) or an array of numbers (one element per circle)
    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawPointsArrayAsCircles( array, x=0, y=0, radius=10, fillColor, strokeColor, strokeWeight=1, chance=1 ){
        DrawTool.startDrawStyle( fillColor, strokeColor, strokeWeight );
        for (let i = 0; i < array.length; i++) {
          if( MathTool.random()<chance){
            const p = array[i];
            let r = Array.isArray(radius)  ? radius[i] : radius;
            //console.log( "drawCircle: ", i, r, p );
            window.p5App.circle( p.x+x, p.y+y, r )
          }
        }
        DrawTool.endDrawStyle();
    }
    
    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawPointsArrayAsLine( array, x=0, y=0 ){
        for (let i = 0; i < array.length-1; i++) {
            const p0 = array[i];
            const p1 = array[i+1];
            window.p5App.line( p0.x+x, p0.y+y, p1.x+x, p1.y+y )
        }
    }


    
    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawPointsArrayAsShape( array, x=0, y=0, p5Instance ){
      p5Instance = p5Instance || window.p5App;
        p5Instance.beginShape();
        for (let i = 0; i < array.length; i++) {
            const p0 = array[i];
            p5Instance.vertex( p0.x+x, p0.y+y );
            //line( p0.x+x, p0.y+y, p1.x+x, p1.y+y )
        }
        p5Instance.endShape(p5Instance.CLOSE);
    }

    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static drawPointsArrayAsCurve( array, x=0, y=0 ){
        window.p5App.beginShape();
        for (let i = 0; i < array.length-1; i++) {
            const p0 = array[i];
            window.p5App.vertex( p0.x+x, p0.y+y );
            //line( p0.x+x, p0.y+y, p1.x+x, p1.y+y )
        }
        window.p5App.endShape();
    }

    // REceived an array of points and draw a line between each point, 
    // bypassing its limits by random size
    static drawSketchLines( points, color="#000000", lineWidth=1, minOffset=10, maxOffset=50, minNumLines=1, maxNumLines=5 ){
      p5App.push();
      p5App.noFill();
      p5App.stroke( color );
      p5App.strokeWeight( lineWidth );
      console.log( "drawSketchLines: ", points );
      for( let i=0; i<points.length-1; i++ ){
        let p0 = points[i];
        let p1 = points[i+1];
        let numLines = minNumLines + Math.floor(MathTool.random()*(maxNumLines-minNumLines));
        for( let j=0; j<numLines; j++ ){
          let offset = minOffset + MathTool.random()*(maxOffset-minOffset);
          let p0Offset = GeomTool.movePoint( p0, offset, p1 );
          let p1Offset = GeomTool.movePoint( p1, offset, p0 );
          p5App.line( p0Offset.x, p0Offset.y, p1Offset.x, p1Offset.y );
        }
      }
      p5App.pop();
    }



    /**
     * 
     * @param {*} p0 
     * @param {*} p1 
     * @param {*} colors 
     * @returns 
     */
    static curveWithRandomCurvature( p0, p1, controlRadius ){
      let c0 = GeomTool.randomPointInCircle( controlRadius, p0.x, p0.y );
      let c1 = GeomTool.randomPointInCircle( controlRadius, p1.x, p1.y );
      window.p5App.curve( c0.x, c0.y, p0.x, p0.y, p1.x, p1.y, c1.x, c1.y )
  }

  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */
  static drawRoundedPath( points, BORDER_RADIUS, fillColor, strokeColor, strokeWeight ){
    console.log( "drawRoundedPath" );
    let ctx = window.p5App.drawingContext;
    /* 
    ctx.beginPath();
    ctx.strokeStyle = 'blue';
    ctx.moveTo(20, 20);
    ctx.lineTo(200, 20);
    ctx.stroke();

    // Second path
    ctx.beginPath();
    ctx.strokeStyle = 'green';
    ctx.moveTo(20, 20);
    ctx.lineTo(120, 120);
    ctx.stroke();
    ctx.save(); 
    */
   // DrawTool.startDrawStyle( fillColor, strokeColor, strokeWeight );
   
   ctx.save(); 
    ctx.beginPath();
    
    if( fillColor )
      ctx.fillStyle = fillColor;
    if( strokeColor )
      ctx.strokeStyle = strokeColor;
    if( strokeWeight )
      ctx.lineWidth = strokeWeight;

    if (!points.length) return;

    //compute the middle of the first line as start-stop-point:
    var deltaY = (points[3] - points[1]);
    var deltaX = (points[2] - points[0]);
    var xPerY = deltaY / deltaX;
    var startX = points[0] + deltaX / 2;
    var startY = points[1] + xPerY * deltaX / 2;

    //walk around using arcTo:
    ctx.moveTo(startX, startY);
    var x1, y1, x2, y2;
    x2 = points[2];
    y2 = points[3];
    for (var i = 4; i < points.length; i += 2) {
        x1 = x2;
        y1 = y2;
        x2 = points[i];
        y2 = points[i + 1];
        ctx.arcTo(x1, y1, x2, y2, BORDER_RADIUS);
    }

    //finally, close the path:
    ctx.arcTo(x2, y2, points[0], points[1], BORDER_RADIUS);
    ctx.arcTo(points[0], points[1], startX, startY, BORDER_RADIUS);
    ctx.closePath();

    if( fillColor )
      ctx.fill();
    
    if( strokeColor || strokeWeight )
      ctx.stroke();
    
    ctx.restore();

   // DrawTool.endDrawStyle(  );
}

/**
 * 
 * @param {*} p0 
 * @param {*} p1 
 * @param {*} colors 
 * @returns 
 */  
static drawTriangle( points, fillColor, strokeColor, strokeWeight ){
    //window.p5App.moveTo( points[0].x, points[0].y );    
    DrawTool.startDrawStyle( fillColor, strokeColor, strokeWeight );
    p5App.triangle( 
      points[0].x, points[0].y, 
      points[1].x, points[1].y, 
      points[2].x, points[2].y
    );
      DrawTool.endDrawStyle(  );
  }

  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */
  static drawTriangles( points, radius, useStroke, useFill ){
    for (let i = 0; i < points.length; i++) {
      if( useStroke ){
        window.p5App.stroke( window.app.clrRandom() );
        window.p5App.strokeWeight( 1+MathTool.random()*10 );
      }else{
        window.p5App.noStroke();
      }
      if( useFill ){
        window.p5App.fill( window.app.clrRandom() );
      }else{
        window.p5App.noFill();
      }
      const p = points[i];
      let pClose = GeomTool.getPointsCloserThan( p, points, radius );
      if( pClose.length >= 3 ){
        let selected = MathTool.randomElementsFromArray(pClose, 3);
        let p0 = selected[0];
        let p1 = selected[1];
        let p2 = selected[2];
        /* let p0 = GeomTool.randomPointInCircle( radius, p.x, p.y );
        let p1 = GeomTool.randomPointInCircle( radius, p.x, p.y );
        let p2 = GeomTool.randomPointInCircle( radius, p.x, p.y ); */
        p5App.triangle( p0.x, p0.y, p1.x, p1.y, p2.x, p2.y );
      }else{
        console.warn( "DrawTool.drawTraingles couldn't find enought near points for triangle" );
      }
    }
  }

  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */
  static drawSpeghetti(points, numLines, minDist, colors ){
    let getConnection = function(points, minDist){
      const p0 = points[ MathTool.randInt(points.length-1) ];
      let p1 = null;
      for (let i = 0; i < 50; i++) {
        const p1Candidate = points[ MathTool.randInt(points.length-1) ];
        let dist = MathTool.distance( p0, p1Candidate );
        if( dist < minDist ){
          minDist = dist;
          p1 = p1Candidate;
        }
      }
      return [p0,p1];
    };
    
    for (let i = 0; i < numLines; i++) {
      let conn = getConnection(points, minDist);
      const p0 = conn[0];
      const p1 = conn[1];
      //console.log( i, "line: ", p0.x, p0.y, p1.x, p1.y );
      /* p5App.stroke( window.app.clrRandom() ); 
      p5App.line( p0.x, p0.y, p1.x, p1.y ); */
      if(!p0 || !p1 )
        continue;
  
      window.p5App.stroke( MathTool.randomElementFromArray( colors ) );
      //let yPos =MathTool.map( (p0.y+p1.y)*.5, cY*0.65, cY*2.95, 0.5, 10 );
      window.p5App.strokeWeight(MathTool.random()*10 );
      const p = points[i];
      p.x +=MathTool.random()*300-150;
      p.y +=MathTool.random()*300-150;
      DrawTool.curveWithRandomCurvature( p0, p1, 500 );
    }
    for (let i = 0; i < points.length; i++) {
      window.p5App.stroke( MathTool.randomElementFromArray( colors )  );
      //window.p5App.stroke( window.app.clrRandom() );
      window.p5App.strokeWeight( 1+MathTool.random()*10 );
      const p = points[i];
      p5App.circle( p.x, p.y,MathTool.random()*2+1)
    }
    for (let i = 0; i < points.length/4; i++) {
      window.p5App.stroke( MathTool.randomElementFromArray( colors )  );
      //window.p5App.stroke( window.app.clrRandom() );
      window.p5App.strokeWeight( 1+MathTool.random()*5 );
      const p = points[i];
      p.x +=MathTool.random()*300-150;
      p.y +=MathTool.random()*300-150;
      p5App.circle( p.x, p.y,MathTool.random()*2+1)
    }

  }
  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */
  static drawSprinkle(points, colors, minRadius, maxRadius ){
    window.p5App.push();
    window.p5App.noStroke();
    for (let i = 0; i < points.length; i++) {
      window.p5App.fill( MathTool.randomElementFromArray( colors )  );
      //window.p5App.stroke( window.app.clrRandom() );
      //window.p5App.strokeWeight( 1+MathTool.random()*10 );
      const p = points[i];
      p5App.circle( p.x, p.y,MathTool.random()*2+1)
    }
    for (let i = 0; i < points.length/4; i++) {
      window.p5App.fill( MathTool.randomElementFromArray( colors )  );
      //window.p5App.stroke( window.app.clrRandom() );
      //window.p5App.strokeWeight( 1+MathTool.random()*5 );
      const p = points[i];
      /* p.x +=MathTool.random()*300-150;
      p.y +=MathTool.random()*300-150; */
      p5App.circle( p.x, p.y,minRadius +  MathTool.random()*(maxRadius-minRadius) );
    }
    window.p5App.pop();
  }

  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */
  static drawCardinalCurve(ctx, pts, resolution){
      // Demo how to use caredinal spline
    //let pts = [ {x:300, y:250}, {x:200, y:150}, {x:80, y:400} ];
    var splinePoints = GeomTool.getCurvePoints( pts, null, resolution );

    ctx.beginPath();
    ctx.save()
    ctx.moveTo(splinePoints[0].x, splinePoints[0].y);
    for (let i = 1; i < splinePoints.length; i++) {
      const point = splinePoints[i];
      ctx.lineTo(point.x, point.y);        
    }
    //ctx.stroke();
    /* for (let i = 1; i < pts.length; i++) {
      const point = pts[i];
      ctx.rect(point.x-5, point.y-5, 10, 10);        
    }
    ctx.stroke(); */
    ctx.restore();
  }

  /**
   * 
   * @param {*} p0 
   * @param {*} p1 
   * @param {*} colors 
   * @returns 
   */
  static drawFlowCurve(flowField, startingPoint, num_steps, step_length, color){
    let x = startingPoint.x;
    let y = startingPoint.y;
    p5App.push();
    //p5App.stroke( '#00000050' );
    p5App.stroke( color );
    p5App.noFill();
    p5App.strokeWeight( MathTool.randInt(3,1) );
    //p5App.strokeCap( p5App.SQUARE );
    p5App.beginShape();
    for (let n=0; n<num_steps; n++) {
      //console.log( "dataFlowCurve loop ", n);
      p5App.vertex(x, y);
      let offsetX = x - flowField.xLeft;
      let offsetY = y - flowField.yTop;
      let columnIndex = parseInt( offsetX / flowField.resolution);
      let rowIndex = parseInt( offsetY / flowField.resolution);
      if( !flowField.grid[columnIndex] || !flowField.grid[columnIndex][rowIndex] ){
          continue;
      }
      let gridAngle = flowField.grid[columnIndex][rowIndex];
      let x_step = step_length * Math.cos(gridAngle);
      let y_step = step_length * Math.sin(gridAngle);
      x = x + x_step
      y = y + y_step
    }
    p5App.endShape(p5App);
    p5App.pop();
  }
}